import api from "data/APIs";

export const ZOOM_ATTENDANCE_API_ENDPOINTS = {
  GET_MEETING_DETAILS: api.attendance.get_meeting_details,
  GET_STATS: "host/get/listing/attendance/stats",
  EXPORT_ATTENDANCE: api.attendance.get_attendance_list_of_listing,
  GET_SESSION_PARTICIPANTS: api.attendance.get_session_participants,
  SEARCH_BOOKED_CUSTOMERS: "host/search/slot/booked/customers",
  MAP_UNRECOGNIZED_PARTICIPANT: "host/map/unrecognized/participant",
};
